import { createApp } from 'vue'
import App from './App.vue'
import toastr from 'toastr'

import PrimeVue from 'primevue/config'
import 'primevue/resources/themes/lara-light-indigo/theme.css'
import 'primevue/resources/primevue.min.css'
import 'primeicons/primeicons.css'
import './assets/css/custom.css'
import './assets/css/custom-theme.css'
import store from './store'
import router from './router'

import axios from './axios'
import VueAxios from 'vue-axios'
import DefaultLayout from './views/layouts/Default.vue'
import EmptyLayout from './views/layouts/Empty.vue'
import outsideClick from './directives'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import Button from 'primevue/button'
import Dropdown from 'primevue/dropdown'
import Avatar from 'primevue/avatar'
import InputText from 'primevue/inputtext'
import Paginator from 'primevue/paginator'
import Checkbox from 'primevue/checkbox'
import Calendar from 'primevue/calendar'
import Skeleton from 'primevue/skeleton'
import Tooltip from 'primevue/tooltip'
import ProgressBar from 'primevue/progressbar'
import Toast from 'primevue/toast'
import { Form, Field } from 'vee-validate'
import Dialog from 'primevue/dialog'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import '@fortawesome/fontawesome-free/css/all.css'
import imgLibrary from './imgLibrary'

const app = createApp(App)

imgLibrary.install = () => {
    Object.defineProperty(app.config.globalProperties, '$images', {
        get () { return imgLibrary }
    })
}
app.use(imgLibrary)
app.use(store)
app.use(router)
app.use(PrimeVue)
app.use(VueAxios, axios)

app.component('DataTable', DataTable)
app.component('Column', Column)
app.component('Button', Button)
app.component('Dropdown', Dropdown)
app.component('Avatar', Avatar)
app.component('InputText', InputText)
app.component('Paginator', Paginator)
app.component('Checkbox', Checkbox)
app.component('Calendar', Calendar)
app.component('default-layout', DefaultLayout)
app.component('empty-layout', EmptyLayout)
app.directive('click-outside', outsideClick)
app.component('Form', Form)
app.component('Field', Field)
app.component('Dialog', Dialog)
app.component('Skeleton', Skeleton)
app.component('ProgressBar', ProgressBar)
app.component('Toast', Toast)
app.directive('tooltip', Tooltip)

toastr.options.positionClass = 'toast-top-right'
store.$axios = axios
app.provide('axios', app.config.globalProperties.axios)
app.config.errorHandler = () => {
    toastr.error('Please contact support team or try again')
}
app.mount('#app')
